import React, { useEffect, useState } from 'react'

import Creatable from 'react-select/creatable'
import { FormControl, useTheme } from '@mui/material'
import { ErrorMessage, Field } from 'formik'
import TextError from './TextError'

/**
 * function to render creatable from react-select
 * @param {*} creatable creatable props for multiselect tag
 * @returns customized react-select
 */

const ReactCreatable = ({
  onChange = () => {},
  isMulti = true,
  disabled = false,
  isEdit,
  ...props
}) => {
  const theme = useTheme()

  const {
    label,
    name,
    formik: { field, form, meta },
    // eslint-disable-next-line no-unused-vars
    ...rest
  } = props
  const [colorError, setColorError] = useState(false)

  useEffect(() => {
    setColorError(meta.error && meta.touched)
  }, [meta.error, meta.touched])

  const customStyles = {
    control: (baseStyles, state) =>
      colorError
        ? {
            ...baseStyles,
            backgroundColor: 'transparent',
           // baseStyles: `0 0 0 1px ${theme.palette.error.main} !important`,
           // borderColor: `${theme.palette.error.main} !important`,
            color: `${theme.palette.error.main} !important`,
          }
        : {
            ...baseStyles,
            backgroundColor: 'transparent',
            //   borderColor: state.isFocused ? 'grey' : `${theme.palette.error.main}`,
          },
    container: styles => ({
      padding: 0,
      height: '40px',
      backgroundColor: 'transparent',
    }),
    placeholder: defaultStyles =>
      colorError
        ? {
            ...defaultStyles,
          ////  backgroundColor: 'transparent',
           // color: `${theme.palette.error.main} !important`,
          }
        : {
            ...defaultStyles,
          //  backgroundColor: 'transparent',
           // color: `${theme.palette.grey[500]}`,
            fontWeight: theme.typography.fontWeightMedium,
          },
    input: defaultStyles =>
      colorError
        ? {
            ...defaultStyles,
          //  backgroundColor: 'transparent',
            color: theme.palette.common.black,
          }
        : {
            ...defaultStyles,
           // backgroundColor: 'transparent',
            color: theme.palette.common.black,
            fontWeight: theme.typography.fontWeightMedium,
          },
    singleValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: 'transparent',
        fontWeight: theme.typography.fontWeightMedium,
      }
    },
    singleValueLabel: (styles, { data }) => ({
      ...styles,
      backgroundColor: 'transparent',
     // color: theme.palette.common.white,
      fontSize: theme.typography.fontSize,
      padding: '2px 4px',
      fontWeight: theme.typography.fontWeightMedium,
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        borderRadius: '20px',
        padding: '2px',
      //  backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontWeight: theme.typography.fontWeightMedium,
      }
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: theme.palette.common.white,
     // backgroundColor: 'transparent',
      fontSize: theme.typography.fontSize,
      padding: '2px 4px',
      fontWeight: theme.typography.fontWeightMedium,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      backgroundColor: 'transparent',
      color: data.color,
      fontSize: theme.typography.body1.fontSize,
      ':hover': {
        //   backgroundColor: data.color,
        color: 'transparent',
        cursor: 'pointer',
        fontWeight: theme.typography.fontWeightMedium,
      },
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
  }

  const updateTags = (tags, form, field) => {
    // if (!tags) {
    //   onChange([])
    //   return
    // }
    const updatedTags = isMulti ? tags.map(tag => tag.value) : tags?.value || ''
    form.setFieldValue(field.name, updatedTags)
    onChange(updatedTags)
  }

  return (
    <FormControl fullWidth error={meta.error && meta.touched}>
      <Creatable
  menuPortalTarget={document.body}
  menuPosition={'fixed'}
  styles={{
    control: (base, state) => ({
      ...base,
      backgroundColor: '#0a0e27', // semi-transparent
      borderColor: state.isFocused ? 'grey' : '#ccc',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'grey',
      },
    }),
    input: (base) => ({
      ...base,
      color: 'white', // visible input text color
    }),
    singleValue: (base) => ({
      ...base,
      color: '#000', // for selected value display
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#000', // for multi-value selected labels
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }}
  components={{
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
  }}
  isMulti={isMulti}
  isDisabled={disabled}
  placeholder={props.label || 'Type and press Enter to add a value'}
  noOptionsMessage={() => props.noOptionMessage || 'Add List'}
  onBlur={field.setFieldTouched}
  defaultValue={
    isMulti
      ? field.value?.map((tag) => ({
          value: tag,
          label: tag,
        }))
      : field.value
      ? {
          value: field.value,
          label: field.value,
        }
      : ''
  }
  getOptionValue={(option) => option.value}
  getOptionLabel={(option) => option.label}
  onChange={(option) => {
    updateTags(option, form, field);
  }}
/>


      <ErrorMessage component={TextError} name={field.name} />
    </FormControl>
  )
}

const TagsField = ({ ...props }) => {
  return (
    <>
      <Field name={props.name}>
        {formik => <ReactCreatable formik={formik} {...props} />}
      </Field>
    </>
  )
}

export default TagsField
